{
  "PageTitle_auth": "Authentication",
  "PageTitle_presence": "Presence",
  "PageTitle_changePassword": "Change Password",
  "PageTitle_forgotPassword": "Forgot Password",
  "PageTitle_changeLanguage": "Change Language",
  "PageTitle_resetPassword": "Reset Password",
  "PageTitle_termsAndConditions": "Terms and Conditions",
  "PageTitle_cookiePolicy": "Cookie Policy",
  "PageTitle_privacyPolicy": "Privacy Policy",
  "PageTitle_mfa": "Multi-Factor Authentication",
  "PageTitle_teamsAuth": "Teams Authentication",
  "PageTitle_insights": "Insights",
  "PageTitle_crmIntegration": "CRM Integration",
  "PageTitle_changeUserAgent": "Change User Agent",
  "NAME": "Router"
}
